<template>
	<div v-if="loading" class="text-center">
	    Building PDF <i class="fa fa-circle-o-notch fa-spin"></i>
	</div>
	<div v-else>
		<div>
			<vue-headful :title="'Email PDF [INSP-'+inspection.InspectionId+'-Date-'+inspection.InspectionDate+'-Jobsite-'+inspection.JobsiteNumber+'] :: MeritEHS'"/>

			<h4 class="py-3 mb-4">
			    <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
			            <router-link :to="`/inspections`">
			                <i class="fa fa-list"></i> Inspections
			            </router-link>
			        </li>
			        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
			            <router-link :to="`/inspections/view/${inspection.InspectionId}`">
			                <inspection-name :inspection="inspection" />
			            </router-link>
			        </li>
			        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">Email PDF</li>
			    </ol>
			</h4>

			<div class="row">
				<div class="col-lg-8">
					<div class="card">
						<div class="card-header">
							Email Inspection PDF
						</div>
						<div class="card-body">
							<div class="form-group row">
							    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.subject }">
							    	Subject: <i class="fa fa-asterisk small text-danger"></i>
							    </label>
							    <div class="col-sm-8">
							    	<b-form-input v-model="subject" name="subject" placeholder="Enter Email Subject" :class="{'is-invalid': errors.subject}" autocomplete="off"></b-form-input>

							        <div v-if="errors.subject" class="text-danger">
							            <div v-for="error in errors.subject">{{ error }}</div>
							        </div>
							    </div>
							</div>
							<div class="form-group row">
							    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true }">
							    	Enter an Email:
							    </label>
							    <div class="col-sm-8">
							    	<b-input-group>
							    		<b-form-input v-model="new_email" name="to" placeholder="Enter Email Recipient" autocomplete="off"></b-form-input>
							    		<b-input-group-append>
							    			<b-button variant="info" v-on:click="addEmailFromEmployee()"><i class="fa fa-plus-circle"></i> Add</b-button>
							    		</b-input-group-append>
							    	</b-input-group>
							    </div>
							</div>
							<div class="form-group row">
							    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true }">
							    	Or Search Employees:
							    </label>
							    <div class="col-sm-8">
							    	<employee-select ref="userEmployee" @vselected="addEmailFromEmployee" :filters="{'has_email': true}"></employee-select>
							    </div>
							</div>
							<div class="form-group row">
							    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true }">
							    	Or Search Users:
							    </label>
							    <div class="col-sm-8">
							    	<user-select ref="userEmail" @vuselected="addEmailFromEmployee" :hasError="errors.user_id ? true : false"></user-select>
                                    <span v-if="errors.user_id" class="text-danger">
                                        <span v-for="error in errors.user_id">{{ error }}</span>
                                    </span>
							    </div>
							</div>
							<div class="form-group row">
							    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.to }">
							    	Recipients: <i class="fa fa-asterisk small text-danger"></i>
							    </label>
							    <div class="col-sm-8">
							    	<strong v-if="to.length == 0" class="mt-2">
							    		-- Enter an Email or Search Employees Above --
							    	</strong>
							    	<ol class="mt-2 list-unstyled">
							    		<li v-for="(email, i) in to" class="mb-1">
							    			<button class="btn btn-xs btn-default" v-on:click="removeEmail(i)"><i class="fa fa-trash text-danger"></i></button> <strong>{{ email }}</strong>
							    		</li>
							    	</ol>

							        <div v-if="errors.to" class="text-danger">
							            <div v-for="error in errors.to">{{ error }}</div>
							        </div>
							    </div>
							</div>
							<div class="form-group row">
							    <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.email_body }">
							    	Body: <i class="fa fa-asterisk small text-danger"></i>
							    </label>
							    <div class="col-sm-8">
							    	<b-form-textarea v-model="email_body" placeholder="Enter Email Body" :class="{'is-invalid': errors.email_body}" rows="6"></b-form-textarea>

							    	<div class="alert alert-info mt-2 mb-2">
							    		Your name and email will be appended to the body of the email.
							    	</div>

							        <div v-if="errors.email_body" class="text-danger">
							            <div v-for="error in errors.email_body">{{ error }}</div>
							        </div>
							    </div>
							</div>
							<div class="form-group row">
							    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
							    	PDF:
							    </label>
							    <div class="col-sm-8 pt-2">
							    	<template v-if="rebuilding">
							    		Rebuilding PDF <i class="fa fa-circle-o-notch fa-spin"></i>
							    	</template>
							    	<a :href="`/files/inspections/email-pdf/${file_name}`" target="_blank" title="Preview PDF" v-else>{{ file_name }}</a>
							    </div>
							</div>
							<div class="form-group row">
							    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
							    	Other Options:
							    </label>
							    <div class="col-sm-8 pt-2">
							    	<b-form-checkbox v-model="hide_na_items" plain :value="true" :unchecked-value="false">Hide N/A Items</b-form-checkbox>
							    </div>
							</div>
							<div class="form-group row">
							    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
							    	Save Recipients &amp; Options for Quick-Use:
							    </label>
							    <div class="col-sm-8 pt-2">
							    	<b-form-checkbox v-model="save_config" :value="true" :unchecked-value="false" plain></b-form-checkbox>
							    </div>
							</div>
							<div class="form-group row" v-if="save_config">
							    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
							    	Quick-Use Config Name:
							    </label>
							    <div class="col-sm-8 pt-2">
							    	<b-form-input v-model="config_name" placeholder="Enter a Name for this Quick-Use Config (Optional)"></b-form-input>
							    </div>
							</div>
						</div>
						<div class="card-footer">
							<button class="btn btn-warning" v-on:click="sendEmailPDF()" :disabled="saving || rebuilding">Email PDF</button>

						</div>
					</div>
				</div>
				<div class="col-lg-4 mt-lg-0 mt-4">
					<h4>Quick-Use Configurations</h4>
					<div class="card mb-2" v-if="configs.length == 0">
						<div class="card-header">
							<i class="fa fa-question-circle"></i> Helper Tip
						</div>
						<div class="card-body">
							<p>You can save these recipients and other options by checking the box "Save Recipients and Options for Quick Use" before sending the PDF.</p>
							<p>This will allow you to re-use these settings the next time you send an Inspection PDF.</p>
						</div>
					</div>
					<template v-else>
						<div class="card mb-2" v-for="config in configs">
							<div class="card-header" v-if="config.config_name">
								<strong>{{ config.config_name }}</strong>
							</div>
							<div class="card-body">
								<div class="mb-2">
									<span>Recipients:</span><br/>
									<ol class="mt-1 list-unstyled">
										<li v-for="(email, i) in config.config_options_decoded.to" class="mb-1">
											<strong>{{ email }}</strong>
										</li>
									</ol>
								</div>
								<div>
									<span>Other Options:</span><br/>
									<template v-if="config.config_options_decoded.hide_na_items == true">
										<strong><i class="fa fa-check-square"></i> Hide N/A Items</strong>
									</template>
								</div>
							</div>
							<div class="card-footer">
								<button class="btn btn-sm btn-info" v-on:click="setConfig(config)">Use Config</button>
								<button class="btn btn-sm btn-default pull-right text-danger" v-on:click="deleteConfig(config)"><i class="fa fa-trash"></i> Delete</button>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import moment from 'moment-timezone';

	export default {
	    data: function() {
	        return {
	            loading: true,
	            rebuilding: false,
	            saving: false,
	            InspectionId: this.$route.params.id,
	            inspection: {},
	            subject: null,
	            new_email: null,
	            to: [],
	            email_body: null,
	            save_config: false,
	            hide_na_items: false,
	            config_name: null,
	            errors: {},
	            insp_config: null,
	            configs: [],
	            options: [],
	        }
	    },

	    watch: {
	    	hide_na_items(newVal, oldVal){
	    		//Rebuild
	    		this.rebuilding = true;

	    		//Fire it
	    		this.getInspection();
	    	}
	    },

	    computed: {
	    	owner_name(){
	    		//Check value
	    		if(this.inspection.hide_creator == 1 && !this.$store.state.user.is_admin)
	    		{
	    			return '';
	    		}

	    		//Default
	    		return this.inspection.owner_first_name+' '+this.inspection.owner_last_name;
	    	},
	    },

	    methods: {

	        getInspection() {
	        	//Build the Payload
	        	var payload = this.$route.query;

	        	//Append
	        	payload['hide_na_items'] = this.hide_na_items;

	            //Get the data
	            this.$http
	                .get('/inspections/email-pdf/'+this.InspectionId, payload)
	                .then(response => {
		                //Set all the data
		                this.inspection = response.data.inspection;
		                this.file_path = response.data.file_path;
		                this.file_name = response.data.file_name;
		                this.configs = response.data.configs;

		                //ONLY Change this if we are NOT rebuilding
		                if(!this.rebuilding)
		                {
		                	//Set the Subject
		                	this.subject = 'MeritEHS PDF for INSP-'+this.InspectionId+' on '+this.inspection.InspectionDate+' for '+this.inspection.JobsiteName;
		                	this.email_body = 'Inspection: '+this.InspectionId+'\n'+
		                						'Date: '+this.inspection.inspection_date_formatted+'\n'+
		                						'Inspected By: '+this.owner_name+'\n'+
		                						'Jobsite: '+this.inspection.JobsiteNumber+'-'+this.inspection.JobsiteName+'\n\n'+
		                						'See attached PDF for Inspection Results';
		                }
	                })
	                .catch(response => {

	                })
	                .then(() => {
	                	//Reset
	                	this.loading = false;
	                	this.rebuilding = false;
	                });
	        },

	        sendEmailPDF() {
	            //Show loading
	            this.saving = true;

	            //Reset the errors
	            this.errors = {};

	            //Setup
	            var payload = {
	            	subject: this.subject,
	            	email_body: this.email_body,
	            	to: this.to,
	            	file_path: this.file_path,
	            	save_config: this.save_config,
	            	insp_email_pdf_id: this.insp_config ? this.insp_config.id : null,
	            	hide_na_items: this.hide_na_items,
	            	config_name: this.config_name,
	            };

                //Get the data
                this.$http
                    .post('/inspections/email-pdf/'+this.InspectionId, payload)
                    .then(response => {
    	                //Alert
    	                this.$toastr.success('PDF Sent');

    	                //Push back
    	                this.$router.push('/inspections/view/'+this.InspectionId);
                    })
                    .catch(error => {
                    	//Check for error
                    	if(error.response.status === 422)
                    	{
                    	    //Display validation errors
                    	    this.errors = error.response.data
                    	}
                    	else
                    	{
                    	    //Alert the user
                    	    this.$toastr.error(error.response.data, 'Failed to Email Inspection PDF');
                    	}
                    })
                    .then(() => {
                    	//Reset
                    	this.saving = false;
                    });
	        },

	        setConfig(config){
	        	//Set it
	        	this.insp_config = config;

	        	//Check ALL
	        	this.to = config.config_options_decoded.to;
	        	this.hide_na_items = config.config_options_decoded.hide_na_items == true ? true : false;
	        	this.config_name = config.config_name;

	        	//Turn on the Flag
	        	this.save_config = true;
	        },

	        deleteConfig(config) {
	        	//Confim
	        	if(!confirm('Are you sure you want to delete this Email PDF Config'))
	        	{
	        		return;
	        	}

                //Get the data
                this.$http
                    .post('/inspections/delete-email-pdf-config/'+config.id)
                    .then(response => {
    	                //Alert
    	                this.$toastr.success('Email PDF Config Deleted');

    	                //Remove it
    	                for(var i = 0; i < this.configs.length; i++)
    	                {
    	                    //Check all the IDs
    	                    if(this.configs[i].id == config.id)
    	                    {
    	                        //Splice it
    	                        this.configs.splice(i, 1);
    	                    }
    	                }
                    })
                    .catch(error => {
                    	//Check for error
                    	if(error.response.status === 422)
                    	{
                    	    //Display validation errors
                    	    this.errors = error.response.data
                    	}
                    	else
                    	{
                    	    //Alert the user
                    	    this.$toastr.error(error.response.data, 'Failed to Delete Email PDF Config');
                    	}
                    })
                    .then(() => {
                    	//Reset
                    	this.saving = false;
                    });
	        },

	        addEmailFromEmployee(employee){
	        	//Check for null
	        	if(employee === null)
	        	{
	        		return;
	        	}

	        	//Check for string
	        	if(typeof employee == 'undefined')
	        	{
	        		//Push it
	        		this.to.push(this.new_email);

	        		//Clear
	        		this.new_email = null;

	        		//Stop here
	        		return;
	        	}

	        	//Push onto the stack
	        	this.to.push(employee.email)
	        	this.to.push(user.email)

	        	//Reset
	        	this.$refs.userEmployee.clearInput();
	        	this.$refs.userEmail.reset();
	        },

	        removeEmail(i){
	        	//Do it
	        	this.to.splice(i, 1);

	        	//Force Update?
	        },
	    },

	    mounted() {
	        //Get the inspections
	        this.getInspection();
	    },
	}
</script>